import { render, staticRenderFns } from "./DischargeReport.vue?vue&type=template&id=a61fde50&"
import script from "./DischargeReport.vue?vue&type=script&lang=js&"
export * from "./DischargeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports